"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var ChartBase_1 = __importDefault(require("../ChartBase"));

var ChartBaseFunctions_1 = require("../ChartBase/ChartBaseFunctions");

var BarChart_meta_1 = require("./BarChart.meta");

var BarChart =
/** @class */
function (_super) {
  __extends(BarChart, _super);

  function BarChart(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = BarChart_meta_1.BAR_CHART_CATEGORY_KEY;
    _this.componentKey = BarChart_meta_1.BAR_CHART_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(BarChart.prototype, "chartBaseProps", {
    get: function get() {
      var _a = this.props,
          dateOptions = _a.dateOptions,
          breakpoints = _a.breakpoints;
      var data = this.props.data; // Attempt to manipulate the data based on the base props

      data = this.applyAxisDateAsNumber(this.props, data); // If the base props does not have dateOptions set and breakpoints are configured
      // See if there is dateOptions set in them

      if (!dateOptions && breakpoints) {
        // We dont need to manipulate the data for each breakpoint
        // as both axis will reference the same dataKey
        var dateOptionsBreakpoint = breakpoints.find(function (breakpoint) {
          return breakpoint.props && breakpoint.props.dateOptions;
        });

        if (dateOptionsBreakpoint) {
          var props = dateOptionsBreakpoint.props;

          if (props) {
            data = this.applyAxisDateAsNumber(props, data);
          }
        }
      }

      return ChartBaseFunctions_1.getChartBaseProps({
        type: 'Bar'
      }, this.configuration, __assign(__assign({}, this.props), {
        data: data
      }));
    },
    enumerable: true,
    configurable: true
  });

  BarChart.prototype.applyAxisDateAsNumber = function (props, data) {
    var elementOverrides = props.elementOverrides,
        dateOptions = props.dateOptions;

    if (dateOptions) {
      if (elementOverrides) {
        var xAxis = elementOverrides.xAxis,
            yAxis = elementOverrides.yAxis;

        if (xAxis && dateOptions.xAxisDateAsNumber) {
          data = ChartBaseFunctions_1.useAxisDateAsNumber(xAxis, data);
        }

        if (yAxis && dateOptions.yAxisDateAsNumber) {
          data = ChartBaseFunctions_1.useAxisDateAsNumber(yAxis, data);
        }
      } else {
        console.warn('No elementOverrides specified when trying to use dateOptions. dateOptions will not be applied');
      }
    }

    return data;
  };

  BarChart.prototype.render = function () {
    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(ChartBase_1.default, __assign({}, this.chartBaseProps)));
  };

  BarChart = __decorate([mobx_react_1.observer], BarChart);
  return BarChart;
}(shared_1.ComponentBase);

exports.BarChart = BarChart;
exports.default = shared_1.InjectedStyledComponent(BarChart, BarChart_meta_1.BAR_CHART_CATEGORY_KEY, BarChart_meta_1.BAR_CHART_COMPONENT_KEY);